import { useEffect } from 'react';
import { useSignalR } from '@s20/hooks/signalr.hooks';

export const JobWorkflowNotificationListener = ({ jobAssignmentIds, onNotification }) => {
    const hub = useSignalR('messageHub');

    useEffect(() => {
        if (!hub) {
            return undefined;
        }

        hub.on('MessageDeliveryStatusUpdated', (payload) => {
            try {
                const { jobAssignmentId } = JSON.parse(payload) ?? {};

                if (jobAssignmentIds.includes(jobAssignmentId)) {
                    onNotification();
                }
            } catch (e) {
                console.info('Unable to decode message delivery status payload', e);
            }
        });

        return () => {
            hub.off('MessageDeliveryStatusUpdated');
        };
    }, [hub, jobAssignmentIds, onNotification]);

    return null;
};
